import { ConfigForm as form, marshal } from './ConfigForm'

const provider = {
  label: 'Wallabag',
  form,
  marshal 
}

export default provider
